<div class="ec-creator-container">
    <mat-horizontal-stepper [disableRipple]="true" [linear]="true" #stepper>
        <ng-template matStepperIcon="edit" let-index="index">
            {{index + 1}}
        </ng-template>
        <mat-step [stepControl]="form1" [editable]="true">
            <div class="app-dialog-background app-dialog-padding">
                <form [formGroup]="form1">
                    <ng-template matStepLabel>
                        <span class="title">{{ 'Create community'|i18n }}</span>
                    </ng-template>
                    <div fxLayout="column" fxLayoutGap="20px">
                        <!-- TENANT -->
                        <div *ngIf="rootNodes.length > 1" fxLayout="row" fxLayoutAlign="start center"
                             fxLayoutGap="30px">
                            <div fxLayout="row" fxLayoutAlign="end" fxFlex="30">{{ ('Client'|i18n) + ':' }}</div>
                            <div fxFlex app-input-container>
                                <mat-select app-small-select
                                            [placeholder]="'Client'|i18n"
                                            formControlName="rootNode">
                                    <mat-option *ngFor="let rootNode of rootNodes" [value]="rootNode">
                                        {{ rootNode.name }}
                                    </mat-option>
                                </mat-select>
                            </div>
                            <div *ngIf="!this.form1.controls.rootNode.pristine && this.form1.controls.rootNode.invalid"
                                 app-error>
                                {{ 'Invalid client'|i18n }}
                            </div>
                            <div fxFlex="20"></div>
                        </div>
                        <!-- NAME -->
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                            <div fxLayout="row" fxLayoutAlign="end" fxFlex="30">{{ ('Name'|i18n) + ':*' }}</div>
                            <div fxFlex app-input-container>
                                <input class="input-font"
                                       app-input
                                       [maxLength]="nameMaxLength"
                                       placeholder="{{'Name'|i18n}}"
                                       formControlName="ecName">
                                <div *ngIf="nameError === 'duplicate'" app-error>
                                    {{ 'Resource {0} already exists'|i18n:form1.controls.ecName.value.trim() }}
                                </div>
                                <div *ngIf="nameError === 'pattern'" app-error>
                                    {{ 'Characters {0} are invalid'|i18n:nameForbiddenCharacters }}
                                </div>
                                <div *ngIf="!this.form1.controls.ecName.pristine && nameError === 'invalid'" app-error>
                                    {{ 'Invalid name'|i18n }}
                                </div>
                            </div>
                            <div fxFlex="20"></div>
                        </div>
                        <!--SUBTYPE-->
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                            <div fxLayout="row" fxLayoutAlign="end" fxFlex="30">{{ ('Type'|i18n) + ':*' }}</div>
                            <div fxFlex app-input-container>
                                <mat-select app-small-select
                                            [placeholder]="'Type'|i18n"
                                            formControlName="subType">
                                    <mat-option [value]="EntitySubType.RENEWABLE_ENERGY_COMMUNITY">
                                        {{
                                        {
                                          type: EntityType.ENERGY_COMMUNITY,
                                          sub_type: EntitySubType.RENEWABLE_ENERGY_COMMUNITY
                                        }|entityType|i18n
                                        }}
                                    </mat-option>
                                    <mat-option [value]="EntitySubType.COLLECTIVE_SELF_CONSUMPTION_GROUP">
                                        {{
                                        {
                                          type: EntityType.ENERGY_COMMUNITY,
                                          sub_type: EntitySubType.COLLECTIVE_SELF_CONSUMPTION_GROUP
                                        }|entityType|i18n
                                        }}
                                    </mat-option>

                                </mat-select>
                            </div>
                            <div *ngIf="!this.form1.controls.subType.pristine && this.form1.controls.subType.invalid"
                                 app-error>
                                {{ 'Invalid sub-type'|i18n }}
                            </div>
                            <div fxFlex="20"></div>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="center">
                            <div fxFlex="30"> &nbsp;</div>
                            <div fxLayout="row" fxLayoutGap="23px" class="ml-32 mr-32 warning-panel">
                                <app-icon icon-color-w name="fas-info-circle"></app-icon>
                                <div>
                                    {{ 'Not modifiable later'|i18n }}
                                </div>
                            </div>
                            <div fxFlex="20"> &nbsp;</div>
                        </div>
                        <app-divider></app-divider>

                        <!-- ACTIVATION DATE -->
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                            <div fxLayout="row" fxLayoutAlign="end"
                                 fxFlex="30">{{ ('Activation date'|i18n) + ':' }}
                            </div>
                            <div fxFlex app-input-container *ngIf="activationDateFormControl.value">
                                <input class="input-font"
                                       app-input
                                       [readonly]="true"
                                       fxFlex="90"
                                       placeholder="{{'Activation date'|i18n}}"
                                       [matDatepicker]="activationDate"
                                       formControlName="activationDate">
                                <div *ngIf="!this.form1.controls.activationDate.pristine && this.form1.controls.activationDate.invalid"
                                     app-error>
                                    {{ 'Invalid date'|i18n }}
                                </div>
                                <mat-datepicker-toggle [for]="activationDate"></mat-datepicker-toggle>
                                <mat-datepicker #activationDate disabled="true"></mat-datepicker>
                                <button app-ghost-button (click)="resetActivationDate()">
                                    <app-icon class="app-icon-right" name="fal-calendar-alt"></app-icon>&nbsp;
                                    {{ 'Reset date'|i18n }}
                                </button>
                            </div>
                            <div fxFlex app-input-container *ngIf="!activationDateFormControl.value">
                                <button app-ghost-button (click)="openActivationDateDialog()">
                                    &nbsp;<app-icon class="app-icon-right" name="fal-calendar-alt"></app-icon>&nbsp;
                                    {{ 'Insert date'|i18n }}
                                </button>
                            </div>
                            <div fxFlex="20"></div>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="start center" class="mt-10">
                            <div fxFlex="26"></div>
                            <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px" class="info-panel">
                                <div fxLayout="row" fxLayoutAlign="start center">
                                    <app-icon name="fas-info-circle"></app-icon>
                                </div>
                                <div fxLayout="column" fxLayoutAlign="start start">
                                    <div>
                                        {{ 'GSE defined date.'|i18n }}
                                    </div>
                                    <div>
                                        {{ 'Energy data and incentives will be accounted for from this date.'|i18n }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <app-divider></app-divider>
                        <div fxLayout="row" class="txt-h-18-7">{{ 'Geographical position'|i18n }}</div>
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
                            <div fxLayout="row" fxLayoutAlign="end" fxFlex="30">{{ ('Office address'|i18n) + ':*' }}
                            </div>
                            <div fxFlex>
                                <app-google-maps-address-autocomplete [formControlRef]="addressFormControl"
                                                                      (addressChange)="addressChange($event)">
                                </app-google-maps-address-autocomplete>
                            </div>
                            <div fxFlex="20"></div>
                        </div>
                    </div>
                </form>
            </div>
            <div fxLayout="row" fxLayoutAlign="start center" class="mt-20">
                <div fxFlex>
                    <button app-ghost-button (click)="cancel()">
                        <app-icon class="app-icon-right" name="fal-times"></app-icon>
                        {{ 'Cancel'|i18n }}
                    </button>
                </div>
                <div fxFlex>&nbsp;</div>
                <div>
                    <button app-primary-button matStepperNext [disabled]="!form1.valid || !form1.dirty">
                        {{ 'Continue'|i18n }}
                        &nbsp;<app-icon class="app-icon-right" name="fal-arrow-right"></app-icon>
                    </button>
                </div>
            </div>

            <ng-template #selectActivationDate let-data let-close="close">
                <div class="select-activation-date">

                    <app-activation-date-dialog (activationDateEmitter)="data.ad = $event">

                    </app-activation-date-dialog>
                    <div class="dialog-actions mt-16" fxLayout="row" fxLayoutAlign="center">

                        <div fxLayout="row" fxLayoutAlign="start center" class="mt-20">
                            <div fxFlex>
                                <button app-ghost-button
                                        (click)="selectActivationDateEvent(null, close)">
                                    {{ 'Cancel'|i18n }}
                                </button>
                            </div>
                            <div fxFlex>&nbsp;</div>
                            <div>
                                <button app-primary-button [disabled]="!data.ad"
                                        (click)="selectActivationDateEvent(data.ad, close)">
                                    {{ 'Confirm date'|i18n }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>

        </mat-step>
        <mat-step [stepControl]="form2">
            <form [formGroup]="form2">
                <ng-template matStepLabel>
                    <span class="title">{{ 'Select representative'|i18n }}</span>
                </ng-template>
                <div class="app-dialog-background app-dialog-padding">
                    <div class="mb-20">{{ 'Select the representative that you want to assign the new community'|i18n }}</div>
                    <!-- REPRESENTATIVE -->
                    <!--                    <div *ngIf="representatives.length > 1" fxLayout="row" fxLayoutAlign="start center"-->
                    <div fxLayout="row" fxLayoutAlign="start center"
                         fxLayoutGap="30px">
                        <div fxLayout="row" fxLayoutAlign="end"
                             fxFlex="30">{{ ('Select representative'|i18n) + ':' }}
                        </div>
                        <!--         <div fxFlex app-input-container>
                                     <mat-select app-small-select
                                                 [placeholder]="'Representative'|i18n"
                                                 formControlName="representative">
                                         <mat-option *ngFor="let representative of representatives" [value]="representative">
                                             {{representative.personal_data.first_name + ' ' + representative.personal_data.first_name}}
                                         </mat-option>
                                     </mat-select>
                                 </div>-->
                        <div fxFlex app-input-container class="device-search-container">
                            <input app-input #representativeSearch class="device-search"
                                   formControlName="representative"
                                   [matAutocomplete]="representativeAutocomplete" [spellcheck]="false"
                                   [placeholder]="'Select representative'|i18n"
                                   (focusout)="onRepresentativeLoseFocus($event)">
                            <app-icon *ngIf="!!representativeFormControl.value" name="fal-times"
                                      class="right-symbol clear"
                                      (click)="onClickResetRepresentativeSearch()">
                            </app-icon>
                            <mat-autocomplete #representativeAutocomplete="matAutocomplete"
                                              [displayWith]="representativeDisplayFn">
                                <mat-option *ngFor="let rep of filteredRepresentatives |async" [value]="rep">
                                    {{ rep.personal_data.first_name + ' ' + rep.personal_data.last_name }}
                                </mat-option>
                            </mat-autocomplete>
                            <svg *ngIf="!representativeFormControl.value" xmlns="http://www.w3.org/2000/svg"
                                 viewBox="0 0 512 512"
                                 class="right-symbol mag-glass">
                                <!--! Font Awesome Pro 6.2.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
                                <path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352c79.5 0 144-64.5 144-144s-64.5-144-144-144S64 128.5 64 208s64.5 144 144 144z"/>
                            </svg>
                        </div>
                        <div>
                            <button app-primary-button (click)="save(true)"
                                    [disabled]="busy || !form2.controls.representative.value">
                                {{ 'Confirm'|i18n }}
                            </button>
                        </div>
                        <div fxFlex="20">

                        </div>
                    </div>
                </div>
            </form>
            <div fxLayout="row" fxLayoutAlign="center center" class="mt-20">
                <div>
                    <button app-ghost-button (click)="save(false)"
                            [disabled]="busy">
                        {{ 'Choose later'|i18n }}
                        &nbsp;<app-icon class="app-icon-right" name="fal-arrow-right"></app-icon>
                    </button>
                </div>
            </div>
        </mat-step>
    </mat-horizontal-stepper>
</div>
